import { render, staticRenderFns } from "./RegisteredOwnerYN.vue?vue&type=template&id=5733b012"
import script from "./RegisteredOwnerYN.vue?vue&type=script&lang=js"
export * from "./RegisteredOwnerYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports